{
  const existing = window.upperdeckysStillFirstImage;

  if (!existing) {
    const animationLoads = new Map();
    const warmObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            warm(entry.target.dataset.udAnimationSrc);
            observer.unobserve(entry.target);
          }
        }, { rootMargin: '1200px 160px' })
      : null;
    const revealObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        }, { rootMargin: '240px 80px' })
      : null;

    function canAnimate() {
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        && !navigator.connection?.saveData;
    }

    function warm(src) {
      if (!canAnimate() || !src) return Promise.resolve(false);
      if (animationLoads.has(src)) return animationLoads.get(src);

      const load = new Promise((resolve) => {
        const preload = new Image();
        preload.decoding = 'async';
        preload.onload = () => resolve(true);
        preload.onerror = () => resolve(false);
        preload.src = src;
      });
      animationLoads.set(src, load);
      return load;
    }

    async function reveal(image, src = image?.dataset.udAnimationSrc) {
      if (!image || !src || image.dataset.udAnimationReady === 'true' || !canAnimate()) return false;
      const token = String(Number(image.dataset.udAnimationToken || 0) + 1);
      image.dataset.udAnimationToken = token;

      if (!await warm(src) || !image.isConnected || image.dataset.udAnimationToken !== token) return false;

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      image.dataset.udAnimationReady = 'true';
      return true;
    }

    function register(image) {
      if (!image?.dataset.udAnimationSrc || !canAnimate()) return;
      if (image.dataset.udAnimationRegistered === 'true') return;
      image.dataset.udAnimationRegistered = 'true';
      if (!warmObserver || !revealObserver) {
        reveal(image);
        return;
      }
      warmObserver.observe(image);
      revealObserver.observe(image);
    }

    function registerAll(root = document) {
      root.querySelectorAll?.('[data-ud-animation-src]').forEach(register);
    }

    window.upperdeckysStillFirstImage = { register, registerAll, reveal, warm };
    registerAll();
    document.addEventListener('DOMContentLoaded', () => registerAll(), { once: true });
    document.addEventListener('shopify:section:load', (event) => registerAll(event.target));
  }
}
